import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Panel from '../../UniformComponents/Panel'

import '../../assets/css/emailLanding.css'
import Button from '../../UniformComponents/Button'
import Typography from '../../UniformComponents/Typography'
import QrLinkModal from './CampaignLinks/QrLinkModal'
import ConfigureLinkModal from './CampaignLinks/ConfigureLinkModal'

@observer
export default class DistributionLandingScreen extends Component {
    componentDidMount() {
        const { distributeStore } = this.props

        distributeStore.getSurveyEmbedding()
        distributeStore.init()
    }

    wizardGoToEmail = () => {
        const {
            distributeStore: { showWizardEmailModal },
        } = this.props

        showWizardEmailModal()
    }

    wizardGoToCampaign = () => {
        const { distributeStore } = this.props

        distributeStore.campaignType = 'campaign'
        distributeStore.showCampaignModal()
    }

    wizardGoToOnsite = () => {
        const { distributeStore } = this.props

        distributeStore.campaignType = 'onsite'
        distributeStore.showCampaignModal()
    }

    wizardGoToIntercept = () => {
        const { distributeStore } = this.props

        distributeStore.campaignType = 'intercept'
        distributeStore.showCampaignModal()
    }

    wizardGoToQR = () => {
        const { distributeStore } = this.props

        distributeStore.campaignType = 'qr'
        distributeStore.showCampaignModal()
    }

    render() {
        const {
            distributeStore,
            distributeStore: {
                initialCampaign,
                initialCampaignLink,
                openQrModal,
                openConfigureLinkModal,
            },
            store,
        } = this.props

        return (
            <div>
                <Panel cssClass="distribute-wizard-container">
                    <div className="wizard-header">
                        <Typography type="h2">{i18n.t('distribute.wizard.title')}</Typography>

                        <div className="wizard-live-pill">
                            <i className="far fa-check" />

                            <Typography type="tiny">{i18n.t('distribute.wizard.live')}</Typography>
                        </div>

                        <div className="wizard-no-tracking-pill">
                            <i className="fal fa-user-slash" />

                            <Typography type="tiny">{i18n.t('distribute.wizard.noTracking')}</Typography>
                        </div>
                    </div>

                    <br />

                    <div className="wizard-input-cta-group">
                        <div className="wizard-fake-input">
                            <Typography color="grey">{initialCampaignLink}</Typography>
                        </div>

                        <Button
                            cssClass="regular primary"
                            icon="fal fa-copy"
                            label={i18n.t('distribute.MAXBI.copySurvey.button')}
                            onClick={() => store.copyText('', 'Survey link')}
                        />

                        <Button
                            cssClass="regular tertiary"
                            icon="fal fa-qrcode"
                            label="QR code"
                            onClick={() => openQrModal(initialCampaignLink, initialCampaign?.uuid)}
                        />

                        <Button
                            cssClass="regular tertiary"
                            icon="fal fa-plus"
                            label={i18n.t('distribute.wizard.anotherLink')}
                        />
                    </div>

                    <br />

                    <Typography type="tiny" color="grey">{i18n.t('distribute.wizard.shareAnywhere')}</Typography>

                    <br />

                    <hr />

                    <br />

                    <div className="wizard-need-to-know-wrapper">
                        <div className="wizard-user-icon-wrapper">
                            <i className="far fa-user-check" />
                        </div>

                        <div className="wizard-need-to-know-text-container">
                            <Typography type="h4">{i18n.t('distribute.wizard.needToKnow')}</Typography>

                            <Typography type="tiny" color="grey">{i18n.t('distribute.wizard.addTracking')}</Typography>
                        </div>
                    </div>

                    <br />

                    <div className="wizard-link-tracking-wrapper">
                        <div className="title-text-wrapper">
                            <i className="fal fa-link" style={{ color: '#715AF8' }} />

                            <Typography type="b">{i18n.t('distribute.wizard.surveyLinkTracking')}</Typography>

                            <Typography type="tiny" color="grey">
                                {i18n.t('distribute.wizard.surveyLinkTracking')}
                            </Typography>
                        </div>

                        <br />

                        <div className="wizard-fake-input">
                            <Typography color="grey">{initialCampaignLink.split('&')[0]}{`{...}`}</Typography>
                            <Typography color="secondary" type="b">&UID=[youruniqueidentifier]</Typography>
                        </div>

                        <br />

                        <div className="wizard-link-tracking-list">
                            <div className="list-item">
                                <i className="fal fa-check" />

                                <Typography type="tiny">{i18n.t('distribute.wizard.trackingList1')}</Typography>
                            </div>

                            <div className="list-item">
                                <i className="fal fa-check" />

                                <Typography type="tiny">{i18n.t('distribute.wizard.trackingList2')}</Typography>
                            </div>

                            <div className="list-item">
                                <i className="fal fa-check" />

                                <Typography type="tiny">{i18n.t('distribute.wizard.trackingList3')}</Typography>
                            </div>
                        </div>

                        <br />

                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                            <div className="wizard-link-tracking-also-wrapper">
                                <i className="fal fa-plus" />

                                <Typography type="tiny-b">{i18n.t('distribute.wizard.canAlsoCarry')}</Typography>

                                <Typography type="tiny">{i18n.t('distribute.wizard.moreVariables')}</Typography>
                            </div>

                            <Button
                                cssClass="regular primary"
                                icon="fal fa-sliders"
                                label={i18n.t('distribute.wizard.configureTracking')}
                                style={{ justifyContent: 'center', textWrap: 'nowrap' }}
                                onClick={() => openConfigureLinkModal(initialCampaign)}
                            />
                        </div>
                    </div>

                    <br />

                    <Button
                        icon={`fal fa-chevron-${distributeStore.moreTrackingVisible ? 'up' : 'down'}`}
                        label={i18n.t(`distribute.wizard.${distributeStore.moreTrackingVisible ? 'hideTracking' : 'moreTracking'}`)}
                        cssClass="regular secondary"
                        onClick={() => distributeStore.toggleMoreTracking()}
                    />

                    {distributeStore.moreTrackingVisible && (
                        <div>
                            <br />

                            <div className="wizard-link-tracking-wrapper">
                                <div className="title-text-wrapper">
                                    <i className="fal fa-address-book" style={{ color: '#16CCC1' }} />

                                    <Typography type="b">{i18n.t('distribute.wizard.uniqueLink')}</Typography>

                                    <Typography type="tiny" color="grey">
                                        {i18n.t('distribute.wizard.linkPerPerson')}
                                    </Typography>
                                </div>

                                <br />

                                <div className="wizard-link-tracking-list">
                                    <div className="list-item">
                                        <i className="fal fa-check" />

                                        <Typography type="tiny">
                                            {i18n.t('distribute.wizard.namedResponses')}
                                        </Typography>
                                    </div>

                                    <div className="list-item">
                                        <i className="fal fa-check" />

                                        <Typography type="tiny">{i18n.t('distribute.wizard.downloadLinks')}</Typography>
                                    </div>
                                </div>

                                <br />

                                <div style={{ display: 'flex', gap: 20 }}>
                                    <div className="wizard-link-tracking-also-wrapper">
                                        <i className="fal fa-plus" />

                                        <Typography type="tiny-b">
                                            {i18n.t('distribute.wizard.canAlsoCarry')}
                                        </Typography>

                                        <Typography type="tiny">
                                            {i18n.t('distribute.wizard.registrationData')}
                                        </Typography>
                                    </div>

                                    <Button
                                        cssClass="regular primary"
                                        label={i18n.t('distribute.wizard.uploadContact')}
                                        icon="fal fa-envelope"
                                        style={{ justifyContent: 'center', textWrap: 'nowrap' }}
                                    />

                                </div>
                            </div>
                        </div>
                    )}

                    <hr style={{ marginTop: '10px' }} />

                    <div className="wizard-bottom-links-container">
                        <Typography type="tiny" color="grey">
                            {i18n.t('distribute.wizard.collectingInPerson')}
                        </Typography>

                        <div onClick={distributeStore.goToOnSite}>
                            <Typography type="tiny" color="secondary" style={{ cursor: 'pointer' }}>
                                {i18n.t('distributionNavigation.onsite')}
                            </Typography>
                        </div>

                        <div onClick={distributeStore.goToIntercept}>
                            <Typography type="tiny" color="secondary" style={{ cursor: 'pointer' }}>
                                {i18n.t('distributionNavigation.websiteIntercept')}
                            </Typography>
                        </div>

                        <div onClick={distributeStore.goToEmbed}>
                            <Typography type="tiny" color="secondary" style={{ cursor: 'pointer' }}>
                                {i18n.t('distributionNavigation.websiteEmbed')}
                            </Typography>
                        </div>
                    </div>
                </Panel>

                <br />

                <Button
                    label="Hide wizard"
                    onClick={distributeStore.goToCampaignLinks}
                    cssClass="regular tertiary"
                    style={{ justifySelf: 'center' }}
                />

                <QrLinkModal distributeStore={distributeStore} />

                <ConfigureLinkModal distributeStore={distributeStore} />
            </div>
        )
    }
}
